import React, { useState, useParams } from 'react'
import { Button, Modal, Row, Col, Form, Alert } from 'react-bootstrap'
import { exportDocumentService, authService } from '../../../_services'
import { faFilePowerpoint, faFileExcel, faFileWord, faFilePdf } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from "react-i18next"
import { SERVER_URL } from '../../../config';

function ExportDocumentButton({uuid, photos, exportDocumentConfiguration, type}) {

	const [email, setEmail] = useState('')
	const [validated, setValidated] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [modalType, setModalType] = useState('EXPORT_JOB')
    const { t } = useTranslation('common')

    const downloadExportDocumentByConfiguration = (configuration) => {
        console.log('downloadExportDocumentByConfiguration')
		let userId = authService.getCurrentUser().id
		console.log(photos.length)
		if (photos.length <= 100) {
			window.location.href = SERVER_URL + '/documentation/downloadExportDocument/' + uuid + '?configuration=' + configuration + '&userId=' + userId
		} else {
			setModalType('EXPORT_JOB')
			setShowModal(true)
		}
    }

    const downloadExportDocumentByType = (type) => {
        console.log('downloadExportDocumentByType')
		let userId = authService.getCurrentUser().id
		console.log(photos.length)

		let errors = photos.filter(photo => !photo.hasData)
		console.log(errors)

		if (errors.length > 0) {
			setModalType('PHOTO_ERROR')
			setShowModal(true)
		} else {
			window.location.href = SERVER_URL + '/documentation/downloadExportDocument/' + uuid + '?type=' + type + '&userId=' + userId
		}
    }

    const handleSubmit = (event) => {
	    event.preventDefault()
	    const form = event.currentTarget
	    if (form.checkValidity() === false) {
	        event.stopPropagation()
	        setValidated(true)
	    } else {
	        handleConfirm()
			setValidated(false)
	    }
	}

	const handleConfirm = () => {
        handleCloseModal()

        if (modalType == 'EXPORT_JOB') {
            let userId = authService.getCurrentUser().id

	        exportDocumentService.createExportDocumentJob(uuid, exportDocumentConfiguration.id, email).then(result => {
				console.log(result)
	        })
        } else if (modalType == 'PHOTO_ERROR') {
            let userId = authService.getCurrentUser().id
            window.location.href = SERVER_URL + '/documentation/downloadExportDocument/' + uuid + '?type=' + type + '&userId=' + userId
        }
    }

    const handleCloseModal = () => {
		setShowModal(false)
    }

    return (
        <>
            { exportDocumentConfiguration &&
                <>
		            <Button variant="outline-dark" onClick={e => downloadExportDocumentByConfiguration(exportDocumentConfiguration.id)}>
						{ exportDocumentConfiguration.type == 'POWERPOINT' &&
							<FontAwesomeIcon icon={faFilePowerpoint} style={{color: '#d04423'}}/>
						}
						{ exportDocumentConfiguration.type == 'EXCEL' &&
							<FontAwesomeIcon icon={faFileExcel} style={{color: '#1f6e43'}}/>
						}
						{ exportDocumentConfiguration.type == 'WORD' &&
							<FontAwesomeIcon icon={faFileWord} style={{color: '#134db2'}}/>
						}
						{ exportDocumentConfiguration.type == 'PDF' &&
							<FontAwesomeIcon icon={faFilePdf} style={{color: '#f70000'}}/>
						}
						{ exportDocumentConfiguration.type == 'WORD_TO_PDF' &&
							<FontAwesomeIcon icon={faFilePdf} style={{color: '#f70000'}}/>
						}
						&nbsp;{exportDocumentConfiguration.name}
					</Button>
					<Button variant="outline-dark" onClick={e => setShowModal(true)} style={{ display: 'none' }}>
						{ exportDocumentConfiguration.type == 'POWERPOINT' &&
							<FontAwesomeIcon icon={faFilePowerpoint} style={{color: '#d04423'}}/>
						}
						{ exportDocumentConfiguration.type == 'EXCEL' &&
							<FontAwesomeIcon icon={faFileExcel} style={{color: '#1f6e43'}}/>
						}
						{ exportDocumentConfiguration.type == 'WORD' &&
							<FontAwesomeIcon icon={faFileWord} style={{color: '#134db2'}}/>
						}
						{ exportDocumentConfiguration.type == 'PDF' &&
							<FontAwesomeIcon icon={faFilePdf} style={{color: '#f70000'}}/>
						}
						{ exportDocumentConfiguration.type == 'WORD_TO_PDF' &&
							<FontAwesomeIcon icon={faFilePdf} style={{color: '#f70000'}}/>
						}
						&nbsp;{exportDocumentConfiguration.name}
					</Button>
				</>
			}
			{ type &&
				<Button variant="outline-dark" onClick={e => downloadExportDocumentByType(type)}>
					{ type == 'FORM_WORD_DOCUMENT' &&
						<>
							<FontAwesomeIcon icon={faFileWord} style={{color: '#134db2'}}/>
							&nbsp;Word
						</>
					}
					{ type == 'FORM_3GIS_PM' &&
						<>
							<FontAwesomeIcon icon={faFileWord} style={{color: '#134db2'}}/>
							&nbsp;Word
						</>
					}
					{ type == 'FORM_SHEAB_WORD_DOCUMENT' &&
						<>
							<FontAwesomeIcon icon={faFileWord} style={{color: '#134db2'}}/>
							&nbsp;Word
						</>
					}
				</Button>
			}
	        <Modal
				style={{overflow: 'scroll'}}
				size="md"
				show={showModal}
				backdrop={true}
				onShow={() => console.log('onShow')}
				onHide={handleCloseModal}
				animation={false}>
				<Modal.Header closeButton>
					<Modal.Title>
						{ modalType == 'EXPORT_JOB' &&
							<span>{ exportDocumentConfiguration ? exportDocumentConfiguration.name : '' }</span>
						}
						{ modalType == 'PHOTO_ERROR' &&
							<span>{t('documentation.exportdocument.photoerror.title')}</span>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{ modalType == 'EXPORT_JOB' &&
						<Form id="export-document-form" noValidate onSubmit={handleSubmit} validated={validated}>
							<div style={{marginBottom: 20}}>
								{t('documentation.exportdocument.message')}
							</div>
							<Form.Group controlId="email">
								<Form.Label>
									{t('documentation.exportdocument.email')}
								</Form.Label>
				                <Form.Control
				                    type="email"
				                    name="email"
				                    value={email}
				                    onChange={e => setEmail(e.target.value)}
				                    required={true}
				                />
				            </Form.Group>
			            </Form>
					}
					{ modalType == 'PHOTO_ERROR' &&
						<div>
							{t('documentation.exportdocument.photoerror.message')}
							<ul style={{marginTop: '1rem'}}>
								{ photos.filter(photo => !photo.hasData).map(photo => {
									return <li key={'photo-error-' + photo.id}>
										{photo.name}
									</li>
								})}
							</ul>
							{t('documentation.exportdocument.photoerror.question')}
						</div>
					}
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={handleCloseModal}>
						{t('crudtable.cancel')}
					</Button>
					{ modalType == 'EXPORT_JOB' &&
						<Button form='export-document-form' type="submit" variant="primary">
							{t('crudtable.ok')}
						</Button>
					}
					{ modalType == 'PHOTO_ERROR' &&
						<Button variant="primary" onClick={handleConfirm}>
							{t('crudtable.ok')}
						</Button>
					}
				</Modal.Footer>
			</Modal>
        </>
    )
}

export default ExportDocumentButton